import React from "react";
import SwiperCore, { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import HomeData from "../../../data/home.json";
import Brand from "../../../components/brand/index";
import PropTypes from "prop-types";

const BrandContainer = ({ contRef }) => {
    SwiperCore.use([Autoplay]);
    const swiperOption = {
        loop: true,
        rewind: "true",
        navigation: true,
        speed: 2000,
        slidesPerView: 2,
        spaceBetween: 0,
        pagination: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        modules: [Autoplay, Navigation],
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 2,
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 2,
            },
            // when window width is >= 640px
            768: {
                slidesPerView: 3,
            },

            // when window width is >= 640px
            992: {
                slidesPerView: 3,
            },
        },
    };
    return (
        <div className="brand-section section-py" ref={contRef}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <Swiper
                            className="brand-carousel"
                            {...swiperOption}
                            onSlideChange={() => console.log("slide change")}
                        >
                            {HomeData[1].brand &&
                                HomeData[1].brand.map((single, key) => {
                                    return (
                                        <SwiperSlide key={key}>
                                            <Brand key={key} data={single} />
                                        </SwiperSlide>
                                    );
                                })}
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
};

BrandContainer.propTypes = {
    contRef: PropTypes.any,
};

export default BrandContainer;
